import {createSlice} from "@reduxjs/toolkit"
// import { persistor } from "./store";

const userSlice=createSlice({
    name:"cart",
    initialState:{
        currentUser:null,
        isFetching:false,
        eror:false
    },
    reducers:{
        loginStart:(state,action)=>{
            state.isFetching=true;
            state.eror=false;
        },
        loginSuccess:(state,action)=>{
            state.isFetching=false;
            state.currentUser=action.payload
        },
        loginFailure:(state,action)=>{
            // console.log({state});
            
            state.isFetching=false;
            state.eror=true
         },

         logOutSuccess:(state,action)=>{
             state.isFetching=false;
             state.currentUser={}
             state.eror=false;
            window.localStorage.removeItem("persist:root");
         },
    }
})

export const {loginStart,loginSuccess,loginFailure,logOutSuccess}=userSlice.actions
export default userSlice.reducer;
export const currentUserSelector=state=>state.user.currentUser;
export const isFetchingSelector=state=>state.user.isFetching;
export const errorSelector=state=>state.user.eror;